import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'

export default function DisplayCurrency({ value = 0, ...rest }) {
  return (
    <NumberFormat
      value={value}
      displayType={'text'}
      {...rest}
      thousandSeparator={'.'}
      decimalSeparator={','}
      prefix={'€'}
    />
  )
}

DisplayCurrency.propTypes = {
  value: PropTypes.number,
}



// WEBPACK FOOTER //
// ./src/components/DisplayCurrency/index.js